import axios from 'axios'

//Defaults will be combined with the instance
axios.defaults.baseURL = window.location.hostname.includes('localhost') ? 'http://localhost:63737/api/': 'https://passwordsecurityportalapi.authlogics.com/api/';

export default axios.create({
	headers: {
		'Accept': 'application/json',
		'Content-Type': 'application/json'
	}
});





// WEBPACK FOOTER //
// ./src/api/index.js